export default "__VITE_ASSET__BSuC$tTv__"